const nissan = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "Altima",
          sideView: require("../../../static/images/carcuts/nissan/side-view/altima_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/altima.png"),
          trims: ["S", "SV", "SR", "SR VC-Turbo", "SL"]
        },
        {
          modelName: "Maxima",
          sideView: require("../../../static/images/carcuts/nissan/side-view/maxima_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/maxima20.png"),
          trims: ["SV", "SR", "Platinum"]
        },
        {
          modelName: "Sentra",
          sideView: require("../../../static/images/carcuts/nissan/side-view/sentra_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/sentra21.png"),
          trims: ["S", "SV", "SR", "SL"]
        },
        {
          modelName: "Versa",
          sideView: require("../../../static/images/carcuts/nissan/side-view/versa_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/versa.png"),
          trims: ["S", "SV", "SR"]
        },
      ],
      suvs: [
        {
          modelName: "Kicks",
          sideView: require("../../../static/images/carcuts/nissan/side-view/kicks_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/kicks20.png"),
          trims: ["S", "SV", "SR"]
        },
        {
          modelName: "Murano",
          sideView: require("../../../static/images/carcuts/nissan/side-view/murano_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/murano20.png"),
          trims: ["S", "SV", "SL", "Platinum"]
        },
        {
          modelName: "Pathfinder",
          sideView: require("../../../static/images/carcuts/nissan/side-view/pathfinder_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/pathfinder.png"),
          trims: ["S", "SV", "SL", "Platinum"]
        },
        {
          modelName: "Rogue",
          sideView: require("../../../static/images/carcuts/nissan/side-view/rogue_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/rogue20.png"),
          trims: ["S", "SV", "SL", "Platinum"]
        },
        {
          modelName: "Rogue Sport",
          sideView: require("../../../static/images/carcuts/nissan/side-view/rogue_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/roguesport20.png"),
          trims: ["S", "SV", "SL"]
        },
      ],
      trucks: [
        {
          modelName: "Frontier",
          sideView: require("../../../static/images/carcuts/nissan/side-view/frontier_side.png"),
          angleView: require("../../../static/images/carcuts/nissan/angle-view/frontier.png"),
          trims: ["S", "SV", "PRO-X", "PRO-4X", "King Cab", "Crew Cab"]
        },
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/nissan/lifestyle/nissan-370z.jpg"),
        sedanImage: require("../../../static/images/carcuts/nissan/lifestyle/nissan-versa.jpg"),
        suvImage: require("../../../static/images/carcuts/nissan/lifestyle/nissan-rogue.jpg"),
        truckImage: require("../../../static/images/carcuts/nissan/lifestyle/nissan-frontier.jpg")
      },
      videoLink: [
        "https://player.vimeo.com/external/309543655.hd.mp4?s=5ff355461965742f5b8fbdd0172a90b6d396fae6&profile_id=175"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/nissan-New.png"), require("../../../static/images/buttons/round-buttons/nissan-Used.png"), require("../../../static/images/buttons/round-buttons/nissan-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/nissan-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/nissan-new.png"), require("../../../static/images/buttons/browse-buttons/nissan-used.png"), require("../../../static/images/buttons/browse-buttons/nissan-service.png"), require("../../../static/images/buttons/browse-buttons/nissan-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/nissan01.png"), require("../../../static/images/buttons/swoop-icons/nissan03.png"), require("../../../static/images/buttons/swoop-icons/nissan02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/nissan/CM-SL-24-Nissan-Established.jpg"), require("../../../static/images/banners/nissan/CM-SL-24-Nissan-Lifestyle.jpg"), require("../../../static/images/banners/nissan/CM-SL-24-Nissan-Modern.jpg"), require("../../../static/images/banners/nissan/CM-SL-24-Nissan-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/nissan/SOKAL-SRS-112321-Pathfinder-Established.jpeg"), require("../../../static/images/banners/nissan/SOKAL-SRS-112321-Pathfinder-Lifestyle.jpeg"), require("../../../static/images/banners/nissan/SOKAL-SRS-112321-Pathfinder-Modern.jpeg"), require("../../../static/images/banners/nissan/SOKAL-SRS-112321-Pathfinder-Playful.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-nissan.png"),
        require("../../../static/images/buttons/logos/dd-logo-nissan-w.png")
      ]
    },
   colors: {
      "--primary-color": "#c3002f",
      "--primary-dark": "#000",
      "--primary-light": "#fff",
      "--secondary-color": "#c4232c",
      "--secondary-dark": "#000",
      "--secondary-light": "#eeeeee",
    },
    fonts: {
      "--heading-text": "NissanBrand-Regular, Verdana, Arial, sans-serif",
      "--subheading-text": "NissanBrand-Bold, Verdana, Arial, sans-serif",
      "--body-text": "NissanBrand-Regular, Verdana, Arial, sans-serif",
      "--bold-text": "NissanBrand-Bold, Verdana, Arial, sans-serif"
    }
  })
}


export default nissan